import { type TranslationTree } from '@/i18n/types';

export const messages = {
  couponTerms: 'Regras do cupom',
  benefit: 'O que o atleta ganha',
  noCoupon: 'Sem cupom',
  actions: 'Botões',
  noActions: 'Sem botões: o atleta mostra o cupom no caixa',
  leadTarget: 'Os contatos de quem aceitar compartilhar aparecem em Resultados',
  directionsTarget: 'Abre o mapa até o local',
  message: 'Mensagem: {{message}}',
  locations: 'Onde vale',
  noLocations: 'Sem endereço',
  audience: 'Público desejado',
  period: 'Período desejado',
  noPreference: 'Sem preferência',
  submittedAt: 'Enviada para análise em',
  reviewedAt: 'Última decisão em',
  audienceNote: 'Público e período são pedidos: a Bodyprint decide o final na campanha.',
} satisfies TranslationTree;
